export const CLINIC_EDIT_FIELDS = [
  "clinic_name",
  "address",
  "phone",
  "clinic_phone",
  "clinic_agent_name",
  "preferred_timezone",
  "country",
  "clinic_info",
  "welcome_message",
  "unifi_scraping_enabled",
  "unifi_console_id",
  "outbound_calls_enabled",
  "outbound_max_concurrent_calls",
  "transfer_campaigns_enabled",
  "opening_hours",
  "elevenlabs_agent_id",
  "elevenlabs_outbound_agent_id",
  "elevenlabs_phone_number_id",
  // PMS integration, provider-agnostic. The legacy scheduling_provider /
  // nexhealth_subdomain / nexhealth_location_id keys are deliberately NOT here:
  // the API still returns them, but it derives them from pms_config, so sending
  // them back would write columns nothing reads any more. Edit the blob.
  "active_pms_provider",
  "pms_config",
  "is_active",
];

// Fields whose value is an object, not a string. They are compared structurally
// and passed through as-is rather than being stringified.
export const CLINIC_JSON_FIELDS = new Set(["opening_hours", "pms_config"]);

// Fields whose value is an integer. They are seeded as numbers, sent as
// numbers, and an empty or unparseable input leaves the key out of the PATCH
// rather than sending "" or null. The value is the draft default when the
// server has none.
export const CLINIC_NUMBER_FIELDS = { outbound_max_concurrent_calls: 1 };

// How many reactivation campaign calls a clinic's AI may place at once. The
// server enforces the same ceiling authoritatively; these only drive the
// input's bounds and its inline hint.
export const OUTBOUND_CONCURRENCY_MIN = 1;
export const OUTBOUND_CONCURRENCY_MAX = 5;

// Countries a clinic can be in, keyed by ISO 3166-1 alpha-2 and carrying the
// E.164 calling code. The backend keeps the same table (app/utils/phone.py);
// the code is shown in the picker so an operator can tell at a glance which
// prefix their patients' numbers will get.
//
// This matters because a PMS stores local numbers -- ABELDent's `pphone` is
// CHAR(10) -- so '9055553732' cannot be dialled until the clinic says which
// country it belongs to. Getting it wrong means calls that never connect.
export const CLINIC_COUNTRIES = [
  { code: "CA", label: "Canada", dial: "+1" },
  { code: "US", label: "United States", dial: "+1" },
  { code: "GB", label: "United Kingdom", dial: "+44" },
  { code: "IE", label: "Ireland", dial: "+353" },
  { code: "AU", label: "Australia", dial: "+61" },
  { code: "NZ", label: "New Zealand", dial: "+64" },
  { code: "DE", label: "Germany", dial: "+49" },
  { code: "FR", label: "France", dial: "+33" },
  { code: "NL", label: "Netherlands", dial: "+31" },
  { code: "AE", label: "United Arab Emirates", dial: "+971" },
];

// Matches the column default. A clinic that has never been edited reads as
// Canada rather than blank, which is what the backend will actually use.
export const DEFAULT_CLINIC_COUNTRY = "CA";
